/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LicenseInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class LicenseApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Licenses');
  }

  patchAttributes(id: number | string, data: Partial<LicenseInterface>): Observable<LicenseInterface> {
    const path = `${id}`;
    return this.patch(path, undefined, data);
  }
}
